import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const TabsStyles = css(
    ({ theme: { spacing, palette, border } }) => css`
        .Tabs {
            .TabGroupContainer {
                gap: ${spacing[6]};
                padding: ${spacing.horizontal(6)};
                border-bottom: ${border.sm};
            }
            .TabsTab {
                color: ${palette.lightText};
                padding: ${spacing.vertical(4)};
                ${getTypographyStyle("body2Strong")};
                &.Active {
                    color: ${palette.text};
                }
            }
            .TabIndicator {
                background: ${palette.primary};
            }
        }
    `,
);
